import { useRef } from "react";
import { saveNewTeamMember } from "api/team";
import { useGlobalToast } from "components/GlobalToastProvider";
import { useMutation } from "react-query";

export const useSaveNewTeamMember = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();
  const lastMutateOptionsRef = useRef({});

  const { mutate, ...rest } = useMutation(
    (params) => saveNewTeamMember(params),
    {
      onError: (error, variables) => {
        const message =
          error?.response?.data?.message || "Whoops! Something went wrong";
        showToast({
          message,
          errorState: true,
          retryHandler: () => mutate(variables, lastMutateOptionsRef.current),
        });
        onError();
      },
      ...otherOptions,
    }
  );

  const saveNewTeamMemberMutation = (params, callOptions = {}) => {
    lastMutateOptionsRef.current = callOptions;
    mutate(params, callOptions);
  };

  return {
    saveNewTeamMemberMutation,
    ...rest,
  };
};
